import React from 'react'

export const WONDERSOFT_COLUMNS = [
  {
    Header: 'Drug Type',
    accessor: 'drugType',
  },
  {
    Header: 'Generic Name',
    accessor: 'genericName',
  },
  { Header: 'Brand Name', accessor: 'brandName' },
  { Header: "DPCO", accessor: "dpco" },
  { Header: "Upper Limit", accessor: "upperLimit" },
  {
    Header: "High Risk", accessor: "highRisk", Cell: (row: any) => {
      return row?.value === true ? (
        <span >YES</span>
      ) : (
        <span > NO</span>
      )
    },
  },
  {
    Header: 'Services', accessor: 'services', Cell: (row: any) => {
      return <span style={{ whiteSpace: 'pre-line' }}>{row.value?.length > 0 ? row.value?.join("\n") : null}</span>
    }
  },
  {
    Header: 'Side Effects',
    accessor: "sideEffects",
    Cell: (row: any) => {
      return <span style={{ whiteSpace: 'pre-line' }}>{row.value?.length > 0 ? row.value?.join("\n") : null}</span>
    },
  },
  {
    Header: '',
    accessor: 'Edit',
    Cell: ({ cell: { } }) => (
      <img
        className="eye-icon"
        src={'assets/images/CRedit.svg'}
        width={32}
        height={30}
        style={{
          marginTop: '6px',
          paddingRight: '15px',
          width: '40px',
          height: '40px',
        }}
        alt="eye"
      />
    ),
  },
]
